module.exports = __webpack_public_path__ + "images/teamlesscolaboration/partypopper.0e17e539436a9486d811.svg";